import { createFileRoute } from '@tanstack/react-router'
import { Settings } from 'lucide-react'
import { lazy, Suspense } from 'react'

import { PageEmpty } from '../components/PageEmpty.js'
import { ThemeSwitch } from '../components/ThemeSwitch.js'

const AccountSettings = lazy(() => import('../components/AccountSettings.js'))

export const Route = createFileRoute('/settings')({
  component: SettingsPage,
})

function SettingsPage() {
  return (
    <div className="flex flex-col gap-8">
      <PageEmpty page="settings" icon={Settings} />
      <Suspense fallback={null}>
        <AccountSettings />
      </Suspense>
      <ThemeSwitch className="max-w-sm" />
    </div>
  )
}
